import { datadogRum } from '@datadog/browser-rum';

/**
 * ブラウザ拡張のエラー
 * @see https://github.com/getsentry/relay/blob/e1ad7bd1e6830c2c88d25f71cc79d5da0fa6ad99/relay-filter/src/browser_extensions.rs
 */
const wellKnownBrowserExtensions = [
  'chrome-extension://',
  'chrome://',
  'moz-extension://',
  'safari-extension://',
  'safari-web-extension://',
];
const wellKnownBrowserExtensionExceptions = ["Can't find variable: gmo"];

/**
 * Datadog RUM の設定
 * @see https://app.datadoghq.com/rum/application
 * @see https://docs.datadoghq.com/real_user_monitoring/guide/monitor-your-nextjs-app-with-rum/?tab=npm
 */
const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
const version = `${process.env.NEXT_PUBLIC_YUFFIE_VERSION_NAME}`.split('-')[0];
if (!!applicationId && !!clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'findy-code',
    env: process.env.NEXT_PUBLIC_YUFFIE_ENV,
    version,
    allowedTracingUrls: [`${process.env.NEXT_PUBLIC_EXCALIBUR_API_URL_BASE}`],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask',
    beforeSend: (event) => {
      if (event.type === 'error') {
        const ignoredErrors = [
          ...wellKnownBrowserExtensions,
          ...wellKnownBrowserExtensionExceptions,
          '<anonymous>',
          'AbortError: ',
          'Abort route change. Please ignore this error.',
          'Error: Cancel rendering route',
          'Invariant: attempted to hard navigate to the same URL',
          'No error message',
          'Non-Error exception captured',
          'Non-Error promise rejection captured',
          'ResizeObserver loop limit exceeded',
          'ResizeObserver loop completed with undelivered notifications.',
          'Failed to initialize NumberFormat since used feature is not supported in the linked ICU version',
        ];
        if (
          ignoredErrors.some((ignoredError) =>
            event.error.message.includes(ignoredError)
          )
        ) {
          return false;
        }
      }
      return true;
    },
  });
}

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
